var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconDesktopAccaGreen = function SvgIconDesktopAccaGreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.667 50.667h18.666A2.666 2.666 0 0 1 44 53.333c0 .737-.597 1.334-1.333 1.334H21.333A1.333 1.333 0 0 1 20 53.333a2.666 2.666 0 0 1 2.667-2.666Z",
    fill: "#239A6D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.667 45.333H25.333v5.334h13.334v-5.334Z",
    fill: "#239A6D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.333 9.333H10.667A2.667 2.667 0 0 0 8 12v30.667a2.667 2.667 0 0 0 2.667 2.666h42.666A2.667 2.667 0 0 0 56 42.667V12a2.667 2.667 0 0 0-2.667-2.667Z",
    fill: "#43DAA0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.027 31.513a5.027 5.027 0 1 0 0-10.053 5.027 5.027 0 0 0 0 10.053Z",
    fill: "#CFFCEC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.53 27.28h-7.387c-.736 0-1.333.597-1.333 1.333V36c0 .736.597 1.333 1.333 1.333h7.387c.736 0 1.333-.597 1.333-1.333v-7.387c0-.736-.597-1.333-1.333-1.333Z",
    fill: "#9EEED3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m41.706 22.513-7.536-5.066a.668.668 0 0 0-1.04.553v10.133c0 .534.597.85 1.04.554l7.536-5.067a.666.666 0 0 0 0-1.107Z",
    fill: "#fff"
  })));
};
export default SvgIconDesktopAccaGreen;